<mat-card *ngIf="!hideCard" class="warning-card">
  <mat-card-content>
    <p>
      Deine E-Mail wurde noch nicht verifiziert. Bitte überprüfen dein Postfach
      und klicke auf den Verifizierungslink.
    </p>
    <mat-divider></mat-divider>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button (click)="resendVerificationEmail()">
      Neue Verifizierungs-E-Mail anfordern
    </button>
  </mat-card-actions>
</mat-card>
